import React, { useState } from 'react';

import classNames from 'classnames';
import { ChevronDown, ChevronUp } from 'lucide-react';

import Helmet from 'common/helmets/Helmet';
import styles from 'css-module/components/www/_Faqs.module.scss';

export type FAQ = {
  question: string;
  html: React.ReactNode | string;
  answer: string;
};

/**
 * @deprecated Please use LandingV3/LandingFAQ instead
 */
interface Props {
  faqs: FAQ[];
}
const FAQs = ({ faqs }: Props) => {
  const [openedQuestions, setOpenedQuestions] = useState<boolean[]>(
    new Array(faqs.length).fill(false)
  );

  const handleClick = (index: number) => {
    const newState = [...openedQuestions];
    newState.splice(index, 1, !openedQuestions[index]);
    setOpenedQuestions(newState);
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((questionObject) => ({
              '@type': 'Question',
              name: questionObject.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: questionObject.answer,
              },
            })),
          })}
        </script>
      </Helmet>
      <section className={styles.FAQs}>
        <h2 className={styles.faqHeader}>Faq</h2>
        <ul className={styles.questionsWrapper}>
          {faqs.map((questionObject, index) => {
            const open = openedQuestions[index];
            return (
              <li
                className={classNames(styles.questionWrapper, { [styles.open]: open })}
                key={index}>
                <button className={styles.question} onClick={() => handleClick(index)}>
                  {questionObject.question}
                  {openedQuestions[index] ? (
                    <ChevronUp className={styles.accordionIcon} />
                  ) : (
                    <ChevronDown className={styles.accordionIcon} />
                  )}
                </button>
                <div className={styles.answer}>{questionObject.html}</div>
              </li>
            );
          })}
        </ul>
      </section>
    </>
  );
};

export default FAQs;
